import * as React from 'react';
import { clsx } from 'clsx';
import styles from './styles.module.css';
import { ensureChildrenVisibility } from '../../../../../select/internal';
import { generateDataTestId } from '../../../../../internal/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function YearPicker(props) {
  const {
    selected,
    onChange,
    width,
    height,
    dataTestId
  } = props;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const initialSelected = React.useMemo(() => selected, []);

  // Предполагаю что людей старше 120 лет не будет
  const min = props.min || initialSelected - 120;
  // Предполагаю что горизон планирования не более 80 лет
  const max = props.max || initialSelected + 79;
  const years = React.useMemo(() => {
    return new Array(max - min + 1).fill(null).map((_, i) => min + i);
  }, [min, max]);
  const containerRef = React.useRef(null);
  const selectedRef = React.useRef(null);
  React.useEffect(() => {
    const selectedElement = selectedRef.current;
    const containerElement = containerRef.current;
    if (!selectedElement || !containerElement) {
      return;
    }
    ensureChildrenVisibility(containerElement, selectedElement);
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    ref: containerRef,
    style: {
      width,
      height
    },
    "data-testid": dataTestId,
    children: /*#__PURE__*/_jsx("div", {
      className: styles['years'],
      children: years.map(year => /*#__PURE__*/_jsx("button", {
        type: "button",
        className: clsx(styles['year'], selected === year && styles['selected']),
        onClick: () => {
          onChange(year);
        },
        ref: selected === year ? selectedRef : null,
        "data-testid": generateDataTestId(dataTestId, ["".concat(year)]),
        children: year
      }, year))
    })
  });
}